import { dialerState } from '../state';
import { DialerState } from '../types';
import IWebPhoneService from '../IWebPhoneService';

const handleWebPhoneDialerStateUpdate = (
  _webPhoneService: IWebPhoneService,
  updatedDialerState: DialerState,
) => {
  // should be kept in sync with https://github.com/servicetitan/telecom-webphone/blob/master/packages/application/src/modules/SoftPhoneModule/state.ts
  dialerState.dialedNumbers = updatedDialerState.dialedNumbers;
  dialerState.actionColor = updatedDialerState.actionColor;
  dialerState.actionDisplay = updatedDialerState.actionDisplay;
};

export default handleWebPhoneDialerStateUpdate;
